import { Button } from "components/atoms/Button";
import { AddIcon, ToolIcon } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import { usePermissions } from "hooks/usePermissions";
import { useState } from "react";
import { UserPermissions } from "utils/enums";
import AddBuildingSidebar from "../AddBuildingSidebar";
import BuildingsCsvUploader from "../BuildingsCsvUploader";

function PageHeader() {
    const { hasPermission } = usePermissions();
    const [buildingSidebarIsOpen, setBuildingSidebarIsOpen] = useState(false);

    return (
        <>
            <div className="page-header">
                <div>
                    <Header size="large">Portfolio</Header>
                </div>
                {hasPermission(UserPermissions.UseInternalTools) && (
                    <Button
                        type="secondary"
                        onClick={() => {
                            window.location.href = "/sandbox";
                        }}
                        icon={<ToolIcon color="black" />}
                        id="sandbox-button"
                    >
                        Sandbox
                    </Button>
                )}
                {hasPermission(UserPermissions.UseInternalTools) && <BuildingsCsvUploader />}
                <Button
                    type="primary"
                    id="add-building-button"
                    onClick={() => setBuildingSidebarIsOpen(true)}
                    icon={<AddIcon color="var(--audette-white)" />}
                >
                    Add building
                </Button>
            </div>
            <AddBuildingSidebar
                onCancel={() => setBuildingSidebarIsOpen(false)}
                sidebarOpen={buildingSidebarIsOpen}
                closeSidebar={() => setBuildingSidebarIsOpen(false)}
            />
        </>
    );
}

export default PageHeader;
